import { QueryClientProvider as TanQueryProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

import queryClient from 'src/shared/api/queryClient';

type QueryProviderProps = {
  children: ReactNode;
};

const QueryClientProvider = ({ children }: QueryProviderProps) => {
  return <TanQueryProvider client={queryClient}>{children}</TanQueryProvider>;
};

export default QueryClientProvider;
